/* eslint-disable i18next/no-literal-string */
import { ButtonLink } from 'components/Button';

import { Box, Typography } from '@mui/material';

import { Trans, useTransl } from 'shared/lib/i18n';

import { downloadCsvFile } from '../Spreadsheet/utils';

const visitorSettings = () => {
  const { t } = useTransl();
  return {
    title: t('instructions.visitorSettings.title'),
    body: (
      <Trans i18nKey="instructions.visitorSettings.body">
        <Box>
          <Typography variant="h6">
            1. Buzzing the Carson panel at the building door.
          </Typography>
          <p>
            All visitors must be created in the Carson app. Once they are
            created, they can buzz the Carson panel when they arrive at the
            building. The call from the panel is then answered by a Carson rep
            that checks the permission list for the visitor. If entry is
            allowed, a notification is sent to the host. If the visitor is not
            on the list, they will not be let in and a rejection notification is
            sent to the host.
            <br />
            Recommended: occasional visitors, visitors who are not tech-savvy.
          </p>
        </Box>
        <Box>
          <Typography variant="h6">2. Using the Carson Visitor App.</Typography>
          <p>
            After creating a visitor, Staff members and residents can send a
            digital key to the visitor. If visitors are created for a timeframe
            of
            <strong> a day or more</strong>, and a digital key is sent to them,
            then these visitors are invited to download the Carson app with
            functionality limited only to opening the common doors (and if
            applicable and permitted the resident&apos;s apartment door). The
            visitor can then use the app to buzz doors open, which will notify
            the host. Once the approved timeframe of the visitor passes, the
            permission to open doors via app lapses.
            <br />
            Recommended uses: repeat visitors, long-term visitors.
          </p>
        </Box>
        <Box>
          <Typography variant="h6">
            3. Sending a text message from the visitor&apos;s mobile phone
          </Typography>
          <p>
            When visitors are created for <strong>a week or less</strong>, they
            receive a text message from Carson and can open designated doors by
            replying to this text message. This text message reply is valid for
            use during the visitor&apos;s timeframe unless they are sent a{' '}
            <strong>15-minutes</strong> key that expires 15 minutes after its
            first use. Upon usage, the host receives a notification.
            <br />
            Recommended uses: one-time visitors, vendors.
          </p>
        </Box>
      </Trans>
    ),
  };
};

const residentImport = () => {
  const { t } = useTransl();

  const data = [
    [
      t('title.unit'),
      t('title.name'),
      t('title.role'),
      t('title.email'),
      t('title.phoneNumber'),
      t('resident.paymentProviderId'),
    ],
    [
      '1A',
      'John Smith',
      'tenant',
      'john@thesmiths.com',
      '16465555555',
      't0200020',
    ],
    [
      '2A',
      'Michelle Jones',
      'tenant',
      'michelle2001@gmail.com',
      '',
      't666006s',
    ],
    ['4D', 'Doris Michael', 'owner', '', '16465555556', ''],
  ];

  const onDownloadSample = () => downloadCsvFile(data, 'Residents sample');

  return {
    title: t('instructions.residentImport.title'),
    body: (
      <Trans i18nKey="instructions.residentImport.body">
        <div>
          The import file must be a csv, xls, or xslx file, with the following
          data for each resident:
        </div>
        <ul>
          <li>Unit</li>
          <li>Name (First Last)</li>
          <li>Role (owner or tenant)</li>
          <li>Email</li>
          <li>
            Phone Number (including the country code, e.g. “+1” for the U.S.)
          </li>
          <li>Payment ID (e.g. a Yardi t-code)</li>
        </ul>
        <div>
          Import files need to include the unit, name, role, and email or phone
          number for each resident.
        </div>
        <Box>
          Please view a sample file
          <ButtonLink
            onClick={onDownloadSample}
            sx={{ verticalAlign: 'unset' }}
          >
            here
          </ButtonLink>
          .
        </Box>
      </Trans>
    ),
  };
};

const dormakabaImport = () => {
  const { t } = useTransl();

  const data = [
    ['AccessPointName', 'AccessPointTypeName'], // cannot be translated due to the api implementation
    ['Name 1', 'Type 1'],
    ['Name 2', 'Type 2'],
    ['Name 3', 'Type 3'],
  ];

  const onDownloadSample = () => downloadCsvFile(data, 'Dormakaba sample');

  return {
    title: t('instructions.dormakabaImport.title'),
    body: (
      <Trans i18nKey="instructions.dormakabaImport.body">
        <div>
          The import file must be a csv file with the following columns:
        </div>
        <ul>
          <li>AccessPointName</li>
          <li>AccessPointTypeName</li>
        </ul>
        <Box>
          Please view a sample file
          <ButtonLink
            onClick={onDownloadSample}
            sx={{ verticalAlign: 'unset' }}
          >
            here
          </ButtonLink>
          .
        </Box>
      </Trans>
    ),
  };
};

const unitImport = () => {
  const { t } = useTransl();

  const data = [
    [t('title.name'), t('title.floor')],
    ['1A', '1'],
    ['1B', '1'],
    ['2A', '2'],
    ['2B', '2'],
    ['2C', '2'],
    ['PHA', '6'],
    ['PHB', '6'],
  ];

  const onDownloadSample = () => downloadCsvFile(data, 'Units sample');

  return {
    title: t('instructions.unitImport.title'),
    body: (
      <Trans i18nKey="instructions.unitImport.body">
        <div>
          The import file must be a csv file with the following columns:
        </div>
        <ul>
          <li>Name</li>
          <li>Floor</li>
        </ul>
        <Box>
          Please view a sample file
          <ButtonLink
            onClick={onDownloadSample}
            sx={{ verticalAlign: 'unset' }}
          >
            here
          </ButtonLink>
          .
        </Box>
      </Trans>
    ),
  };
};

const INFO_DATA = {
  visitorSettings,
  residentImport,
  dormakabaImport,
  unitImport,
};

export default INFO_DATA;
